import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { staffApi } from "./staffApi";
import { DashboardSummary } from "../types/dashboard";

async function fetchSummary(): Promise<DashboardSummary> {
  const res = await staffApi.get("/dashboard/summary");
  return res.data;
}

export function useDashboardSummary(): UseQueryResult<DashboardSummary> {
  return useQuery({
    queryKey: ["dashboard", "summary"],
    queryFn: fetchSummary,
  });
}
